import { PublicApiClient } from "../utils/ApiConfig";

export const GetVideoServices = (page=1,text='') => {
    return PublicApiClient.get(`/project_website/video/get?page=${page}&text=${text}&limit_data=100`);
  };
  
export const GetVideoDetailServices = (id,page=1,text='') => {
    return PublicApiClient.get(`/project_website/video/get/${id}?page=${page}&text=${text}`);
  };